<template>
  <div :class="$style.noFoundItem">
    <img
      src="static/promo-static/landing-2021/src/images/pages/cases/index/not-found-icon.svg"
      alt="По заданным параметрам кейсы не найдены"
    />
    <p :class="$style.text">
      По&nbsp;заданным параметрам кейсы не&nbsp;найдены. Попробуйте выбрать другую отрасль и&nbsp;задачу
    </p>
    <div :class="$style.buttonWrap">
      <base-button @click="openFilter" :class="$style.button">Поменять параметры</base-button>
      <base-button @click="clearFilter" :class="[$style.button, $style.inverted]">Показать все кейсы</base-button>
    </div>
  </div>
</template>

<script>
import 'huntkit/hunt-kit.css';
import { BaseButton } from 'huntkit';

export default {
  name: 'NoFoundItem',
  components: {
    BaseButton,
  },
  methods: {
    openFilter() {
      this.$emit('openFilter');
    },
    clearFilter() {
      this.$emit('clearFilter');
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.button {
  box-shadow: unset !important;

  &:not([disabled], .inverted):hover {
    background-color: #323235;
  }
}

.inverted {
  background-color: rgba(255, 255, 255, 0.6);
  color: #1d1d1f;

  @include mixins.hover {
    &:hover {
      background: rgba(255, 255, 255, 1);
    }
  }
}

.noFoundItem {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 25px;
  background-color: #f3f4f7;
  border-radius: 20px;

  @include mixins.media(md) {
    padding: 24px 24px 52px;
  }

  .text {
    @include mixins.font(1.6rem, 1.55);

    max-width: 506px;
    text-align: center;

    @include mixins.media(md) {
      @include mixins.font(1.8rem, 1.45);

      letter-spacing: -0.005em;
    }
  }

  .buttonWrap {
    margin-top: 16px;
  }

  button {
    height: 33px;
    padding: 4px 12px;
    border-radius: 32px;

    @include mixins.media(sm, max) {
      @include mixins.size(100%, 40px);

      border-radius: 6px;

      & + button {
        margin-top: 0.8rem;
      }
    }
  }
}
</style>
